import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PageHeader({ title, subtitle, actions }) {
    return (_jsxs("div", { className: "main__head", children: [_jsxs("div", { children: [_jsx("h1", { className: "ard-h1 main__title", children: title }), subtitle && _jsx("div", { className: "main__sub", children: subtitle })] }), actions && _jsx("div", { className: "main__actions", children: actions })] }));
}
//# sourceMappingURL=PageHeader.js.map